module.exports = __webpack_public_path__ + "static/media/skill_officeEnvironment.3593f291.png";